"use client";
import Image from "next/image";
import React, { useCallback, useEffect, useState } from "react";
import moengage from "@moengage/web-sdk";
import { useRouter } from "@/i18n/routing";
import { useTranslations } from "next-intl";
import { Logout } from "@mui/icons-material";
import { ButtonComponent } from "@/components";
import { useGetCustomerQuery } from "@/lib/redux";
import Languageswitch from "@/i18n/languageswitch";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import { AppBar, Stack, Toolbar, Typography } from "@mui/material";
import LogoutConfirmationModal from "@/screens/logout/LogoutConfirmationModal";


const DashboardNav = ({ tokenExist, setTokenExist }) => {
  const router = useRouter();
  const t = useTranslations("Login");
  const { data: customerData } = useGetCustomerQuery("", {
    skip: !tokenExist,
  });

  const [logoutModal, setLogoutModal] = useState(false);

  const handleLogout = useCallback(async () => {
    moengage.destroy_session();
    sessionStorage.clear();
    setTokenExist(false);
    window.location.reload();
  }, [setTokenExist]);

  const onClickLogout = useCallback(() => {
    setLogoutModal(false);
    handleLogout();
  },[handleLogout]);

  useEffect(() => {
    if (window !== undefined && sessionStorage.token) {
      setTokenExist(true);
    }
  }, []);
  return (
    <>
      <AppBar position="static" sx={{ bgcolor: WEB_COLORS.pale }}>
        <Toolbar>
          <Stack
            flexGrow={1}
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}>
            <Stack direction={"row"} gap={2} alignItems={"center"}>
              <Image
                width={110}
                height={80}
                alt="Hero FinCorp"
                src={IMAGES.navbarLogo}
              />
            </Stack>
            <Stack direction={"row"} justifyContent={"space-between"} gap={2}>
              <Typography
                sx={{
                  color: WEB_COLORS.primary,
                  display: { xs: "none", sm: "flex" },
                  alignItems: "center",
                  wordSpacing: 1,
                  textWrap: "nowrap",
                }}
                fontFamily={"inherit"}
                variant="subtitle2"
                textTransform={"capitalize"}>
                {t("welcomeguest")}{" "}
                <strong style={{ marginLeft: "5px" }}>
                  {" "}
                  {customerData?.data?.firstName && customerData?.data?.lastName
                    ? `${customerData?.data?.firstName?.toLowerCase()} ${customerData?.data?.lastName?.toLowerCase()}`
                    : t("guest")}
                </strong>
              </Typography>
              {tokenExist && (
                <ButtonComponent
                  toolTipTitle={t("loginttoltip")}
                  onClick={() => setLogoutModal(true)}
                  startIcon={<Logout />}>
                  {t("logout")}
                </ButtonComponent>
              )}
            </Stack>
          </Stack>
        </Toolbar>
      </AppBar>
      <Languageswitch />
      <LogoutConfirmationModal
        onSubmit={onClickLogout}
        onReject={() => setLogoutModal(false)}
        open={logoutModal}
      />
    </>
  );
};

export default DashboardNav;
